export const CALENDARS_GET = 'CALENDARS_GET';
export const CALENDAR_ADD = 'CALENDAR_ADD';
export const CALENDAR_EDIT = 'CALENDAR_EDIT';
export const CALENDAR_GET = 'CALENDAR_GET';
export const CALENDAR_STATUS = 'CALENDAR_STATUS';
export const CALENDAR_DELETE = 'CALENDAR_DELETE';
export const CALENDAR_IMPORT = 'CALENDAR_IMPORT';
export const CALENDAR_YEARS_GET = 'CALENDAR_YEARS_GET';